import { Modal } from "./Modal";
import { Button } from "./ui/Button";
import type { Project, Task } from "../types";

interface Props {
  project: Project;
  openTasks: Task[];
  onConfirm: () => void;
  onClose: () => void;
}

export function ArchiveDialog({ project, openTasks, onConfirm, onClose }: Props) {
  const listed = openTasks.slice(0, 6);
  return (
    <Modal
      title={`Archive ${project.name}`}
      subtitle="It leaves the main view and becomes read only. Nothing is deleted."
      onClose={onClose}
      actions={
        <>
          <Button variant="quiet" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onConfirm}>
            Archive project
          </Button>
        </>
      }
    >
      {openTasks.length > 0 && (
        <div className="banner">
          {openTasks.length} task{openTasks.length === 1 ? " is" : "s are"} still
          open:
          <br />
          {listed.map((t) => (
            <span key={t.id}>
              {t.title}
              <br />
            </span>
          ))}
          {openTasks.length > listed.length && (
            <>and {openTasks.length - listed.length} more</>
          )}
        </div>
      )}
    </Modal>
  );
}
